import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetZillowModel, SetZillowPathway } from '../../actions';
import { gaEvent, togglePanel } from '../../utils/utils';
import withStyles from '../../decorators/withStyles';
import styles from './ZillowPathway.css';


class ZillowPathway extends Component {

  static propTypes = {
    handleAdvancedClick: PropTypes.func.isRequired,
    zillowModel: PropTypes.string.isRequired,
    pathways: PropTypes.array.isRequired,
    groupName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    pathways: ['RCP26', 'RCP45', 'RCP85'],
    groupName: 'Climate pollution scenario',
  };

  handleModelToggle = () => {
    const { zillowModel } = this.props;
    // gaEvent('configure', 'zillowModel-preset', this.checked);
    const model = zillowModel === 'DP16' ? 'BK' : 'DP16';
    this.props.dispatch(SetZillowModel(model));
  };

  handlePathwayClick = (idx) => {
    gaEvent('configure', 'zillowPathway-preset', this.props.pathways[idx]);
    this.props.dispatch(SetZillowPathway(this.props.pathways[idx]));
  };

  render() {
    const { pathways, zillowModel, zillowPathway } = this.props;

    const isActive = (idx) => pathways[idx] === zillowPathway ? "active" : "";

    return (
      <div className="ZillowPathway">
        <div className="collapsible-panel">
          <h4 className="panel-tab" onClick={togglePanel}>{this.props.groupName}</h4>
          <div className="panel-content">
            <div className="panel-content-container">
              <div className="PresetButtons">
                <button onClick={this.handlePathwayClick.bind(null, 2)}
                  className={"preset top fast " + isActive(2)}>High
                </button>
                <button onClick={this.handlePathwayClick.bind(null, 1)}
                  className={"preset middle med " + isActive(1)}>Medium
                </button>
                <button onClick={this.handlePathwayClick.bind(null, 0)}
                  className={"preset bottom slow " + isActive(0)}>Low
                </button>
              </div>
              <div className="modelSwitch">
                <label class="switch">
                  <input type="checkbox" onChange={this.handleModelToggle} checked={zillowModel === "DP16"}/>
                  <span class="slider round"></span>
                </label>
                <div class="label">Include Antarctic dynamics</div>
              </div>
              <div className="advanced">
                <a className="small-text" href="" onClick={(e) => {e.preventDefault(); this.props.handleAdvancedClick(e);}}>Advanced</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function stateToProps(state) {
  return {
    zillowPathway: state.zillowPathway,
  };
}

export default compose(
  withStyles(styles),
  connect(stateToProps),
)(ZillowPathway);
